import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen
				titles={['Bottom Heavy / Core']}
				texts={['Yes your workout starts now']}
				BGImage={CategoryScreenBG}
			/>
			<MultiHalfText first='Workout 01' mt={true} />
			<RoundScreen
				mt={false}
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Pulse Squat',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Flutter Kicks',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Side Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Russian Twist',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'Curtsey Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Toe Touches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads/Glutes',
							value: 'RDL’s w/DB or KB',
						},
						{
							header: 'Sets / Reps',
							value: '3 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
